import type { ProcedureCard } from "../types";
import { CardArt } from "./CardArt";

interface Props {
  card: ProcedureCard;
  established?: boolean;
  cooldown?: number;
  onClick?: () => void;
  onDetail?: () => void;
  disabled?: boolean;
}

export function CardView({ card, established, cooldown, onClick, onDetail, disabled }: Props) {
  return (
    <div
      className={`card ${established ? "established" : ""}`}
      data-disabled={disabled || (cooldown ?? 0) > 0 ? "true" : "false"}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.();
        }
      }}
    >
      <div className="art">
        {card.imageUrl ? (
          <img src={card.imageUrl} alt="" loading="lazy" />
        ) : (
          <CardArt cardId={card.id} kind="procedure" height={100} />
        )}
      </div>
      <div className="body">
        <div className="name">{card.name}</div>
        <div className="desc">{card.description}</div>
      </div>
      {(cooldown ?? 0) > 0 && <div className="cooldown">{cooldown}</div>}
      {onDetail && (
        <button
          className="detail-btn"
          aria-label={`Details for ${card.name}`}
          onClick={(e) => { e.stopPropagation(); onDetail(); }}
        >
          ⓘ
        </button>
      )}
    </div>
  );
}
